module.exports = __webpack_public_path__ + "static/media/tick-rounded.e7be5450.svg";